module.exports = __webpack_public_path__ + "static/media/FloatingIslands.bb7e0d05.png";